export const TRADES_UPDATED_EVENT = 'tradetracker:trades-updated';

export function notifyTradesUpdated(accountId?: string) {
  window.dispatchEvent(new CustomEvent(TRADES_UPDATED_EVENT, { detail: { accountId } }));
}
